import { filter, OperatorFunction } from 'rxjs';

export function filterEmptyObject<T>(): OperatorFunction<T, NonNullable<T>> {
  return filter((value: T): value is NonNullable<T> => value.constructor === Object && Object.keys(value).length > 0);
}
